import { createContext, ReactNode } from "react";

export interface DetailPanelContext {
  openPanel: (
    component: ReactNode,
    props?: { onClose?: () => void; attributes?: Record<string, unknown> },
  ) => void;
  closePanel: () => void;
  attributes?: Record<string, unknown>;
}

const defaultDetailPanelContext: DetailPanelContext = {
  openPanel: () => {},
  closePanel: () => {},
};

export const DetailPanelContext = createContext(defaultDetailPanelContext);
